module.exports = "/images/bus_reverse.png?2b5023e9b0d6bc6c5ecdd6732390d67d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/bus_reverse.png
// module id = h6Uo
// module chunks = 0